export const EMERGENCY_MESSAGE =
  "If there is an immediate danger or medical emergency, follow Deluxe Travel Training's emergency procedures and contact the appropriate emergency service where required. Do not rely on this application as the sole method of obtaining emergency assistance.";

export const INCIDENT_CATEGORIES = [
  { value: "road_safety_incident", label: "Road safety incident" },
  { value: "road_traffic_accident", label: "Road traffic accident" },
  { value: "public_transport_incident", label: "Public transport incident" },
  { value: "child_lost_unaccounted", label: "Child lost / temporarily unaccounted for" },
  { value: "wrong_bus_train", label: "Wrong bus / train" },
  { value: "missed_stop", label: "Missed stop" },
  { value: "transport_disruption", label: "Transport disruption" },
  { value: "injury_accident", label: "Injury / accident" },
  { value: "illness", label: "Illness" },
  { value: "behaviour_safety", label: "Behaviour relevant to safety" },
  { value: "aggression_violence", label: "Aggression / violence" },
  { value: "bullying_harassment", label: "Bullying / harassment" },
  { value: "stranger_approach", label: "Stranger approach" },
  { value: "theft_loss_property", label: "Theft / loss of property" },
  { value: "travel_card_issue", label: "Travel card issue" },
  { value: "mobile_phone_issue", label: "Mobile phone issue" },
  { value: "trainer_safety_intervention", label: "Trainer safety intervention" },
  { value: "near_miss", label: "Near miss" },
  { value: "environmental_hazard", label: "Environmental hazard" },
  { value: "other", label: "Other" },
];

export const INCIDENT_CATEGORY_LABELS = Object.fromEntries(INCIDENT_CATEGORIES.map((c) => [c.value, c.label]));

export const INCIDENT_SEVERITIES = [
  { value: "low", label: "Low" },
  { value: "moderate", label: "Moderate" },
  { value: "high", label: "High" },
  { value: "critical", label: "Critical" },
];

export const SEVERITY_COLORS = {
  low: "bg-slate-100 text-slate-600 border-transparent",
  moderate: "bg-amber-100 text-amber-800 border-transparent",
  high: "bg-red-50 text-red-700 border-transparent",
  critical: "bg-red-600 text-white border-transparent",
};

export const INCIDENT_STATUS_LABELS = {
  draft: "Draft",
  new: "New",
  awaiting_review: "Awaiting review",
  under_review: "Under review",
  actions_outstanding: "Actions outstanding",
  closed: "Closed",
  reopened: "Reopened",
};

export const INCIDENT_STATUS_COLORS = {
  draft: "bg-amber-100 text-amber-800 border-transparent",
  new: "bg-blue-50 text-blue-700 border-transparent",
  awaiting_review: "bg-blue-50 text-blue-700 border-transparent",
  under_review: "bg-purple-50 text-purple-700 border-transparent",
  actions_outstanding: "bg-amber-100 text-amber-800 border-transparent",
  closed: "bg-ukgreen-light text-ukgreen border-transparent",
  reopened: "bg-red-50 text-red-700 border-transparent",
};

export const ACTION_STATUS_LABELS = {
  open: "Open",
  in_progress: "In progress",
  completed: "Completed",
  overdue: "Overdue",
  cancelled: "Cancelled with reason",
};

export const ACTION_STATUS_COLORS = {
  open: "bg-blue-50 text-blue-700 border-transparent",
  in_progress: "bg-amber-100 text-amber-800 border-transparent",
  completed: "bg-ukgreen-light text-ukgreen border-transparent",
  overdue: "bg-red-50 text-red-700 border-transparent",
  cancelled: "bg-slate-100 text-slate-500 border-transparent",
};

export const SAFEGUARDING_CATEGORIES = [
  { value: "physical_abuse_concern", label: "Physical abuse concern" },
  { value: "emotional_abuse_concern", label: "Emotional abuse concern" },
  { value: "sexual_abuse_concern", label: "Sexual abuse concern" },
  { value: "neglect_concern", label: "Neglect concern" },
  { value: "exploitation_concern", label: "Exploitation concern" },
  { value: "bullying", label: "Bullying" },
  { value: "online_safety", label: "Online safety" },
  { value: "missing_child_concern", label: "Missing child concern" },
  { value: "self_harm_safety_concern", label: "Self-harm / safety concern" },
  { value: "domestic_abuse_related", label: "Domestic abuse related concern" },
  { value: "discrimination_hate_incident", label: "Discrimination / hate incident" },
  { value: "inappropriate_adult_contact", label: "Inappropriate adult contact" },
  { value: "peer_on_peer_concern", label: "Peer-on-peer concern" },
  { value: "staff_conduct_concern", label: "Staff conduct concern" },
  { value: "other_safeguarding_concern", label: "Other safeguarding concern" },
];

export const SAFEGUARDING_CATEGORY_LABELS = Object.fromEntries(SAFEGUARDING_CATEGORIES.map((c) => [c.value, c.label]));

export const SG_STATUS_LABELS = {
  new: "New",
  urgent_review_required: "Urgent review required",
  under_review: "Under review",
  action_required: "Action required",
  referred_externally: "Referred externally",
  monitoring: "Monitoring",
  closed: "Closed",
  reopened: "Reopened",
};

export const SG_STATUS_COLORS = {
  new: "bg-blue-50 text-blue-700 border-transparent",
  urgent_review_required: "bg-red-600 text-white border-transparent",
  under_review: "bg-purple-50 text-purple-700 border-transparent",
  action_required: "bg-amber-100 text-amber-800 border-transparent",
  referred_externally: "bg-indigo-50 text-indigo-700 border-transparent",
  monitoring: "bg-blue-50 text-blue-700 border-transparent",
  closed: "bg-ukgreen-light text-ukgreen border-transparent",
  reopened: "bg-red-50 text-red-700 border-transparent",
};

export const TRAINING_DECISIONS = [
  { value: "continue_training", label: "Continue training" },
  { value: "continue_with_additional_controls", label: "Continue with additional controls" },
  { value: "pause_programme", label: "Pause programme" },
  { value: "request_risk_review", label: "Request risk review" },
  { value: "request_journey_review", label: "Request journey review" },
  { value: "request_additional_assessment", label: "Request additional assessment" },
];

export const EVIDENCE_TYPES = [
  { value: "photograph", label: "Photograph" },
  { value: "document", label: "Document" },
  { value: "screenshot", label: "Screenshot" },
  { value: "written_statement", label: "Written statement" },
  { value: "other", label: "Other authorised evidence" },
];

export const DISCLOSURE_GUIDANCE =
  "Record factual information and the child's account accurately. Do not conduct your own investigation. Do not ask leading questions. Follow organisational safeguarding procedures.";
